<template>
  <mdb-dropdown-item
    :tag="notification.link ? 'a' : 'div'"
    :href="notification.link || null"
    class="notification-entry d-flex align-items-start"
  >
    <div class="notification-icon mr-2">
      <mdb-icon :icon="notification.icon || 'info-circle'" />
    </div>
    <div class="notification-body">
      <div class="notification-title font-weight-bold">
        {{ notification.title }}
      </div>
      <div class="notification-message text-small">
        {{ notification.message }}
      </div>
      <div class="notification-time text-muted text-small">
        {{ formattedTime }}
      </div>
    </div>
  </mdb-dropdown-item>
</template>

<script>
export default {
  name: 'NotificationItem',
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedTime() {
      const d = this.notification.date;
      if (d) {
        const date = new Date(d);
        return date.toLocaleString();
      }
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.notification-entry {
  padding: 0.5rem 1rem;
}
.notification-icon {
  flex-shrink: 0;
}
.notification-body {
  flex-grow: 1;
}
.notification-title {
  margin-bottom: 0.25rem;
}
.notification-message {
  margin-bottom: 0.25rem;
}
</style>